angular.module('MoreAppsServices', ['MoreAppsConstants', 'ngResource', 'angularFileUpload']);
